import React, { useRef } from 'react';
import { 
    defineBlock, 
    smartProps,
    useInspectorControl,
    useSmartProp,
    useEditor
} from "@smartfire/gutenberg-react";
import clsx from "clsx";
import { PanelBody, PanelRow, ToggleControl } from "@wordpress/components";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import {useChildrenBlocks} from "../shared/useChildrenBlocks";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import 'swiper/swiper-bundle.css';
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css"

import style from "./block.module.scss";

SwiperCore.use([Autoplay, Navigation, Pagination]);

const Inspector = () => {
    const [fullWidth, setFullWidth] = useSmartProp("fullWidth");

    return (
        <>
            <PanelBody title="Configuration du bouton" initialOpen={true}>
                <PanelRow>
                    <ToggleControl
                        label="Pleine largeur"
                        checked={ fullWidth }
                        onChange={ () => setFullWidth(!fullWidth) }
                    />
                </PanelRow>
            </PanelBody>
        </>
    );

}

const SwiperBlock = ({ Child, domChildren }) => {
    const swiper = useRef();
    const swiperNext = useRef(null);
    const swiperPrev = useRef(null);

    // Swiper configuration
    const sliderSettings = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: swiperNext.current,
            prevEl: swiperPrev.current,
        },
        pagination: {
            "clickable": true,
        },
        speed: 500,
    };


    // When click on tile, the autoplay stop
    const handleAutoplayStop = () => {
        if (swiper.current) {
            swiper.current.swiper.autoplay.stop();
        }
    }

    return (
        <div className={style.swiper}>
            {domChildren && (
                <Swiper tag="section" {...sliderSettings} ref={swiper} onClick={handleAutoplayStop}>
                    {domChildren.map((_, i) => {
                        return (
                            <SwiperSlide key={"testimony-tile-" + i}>
                                <div key={_}>
                                    <Child index={i} />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
            
            <div className={clsx(style.navEl, style.navElLeft, domChildren && domChildren.length === 1 && style.hide)} ref={swiperPrev}><ArrowForwardIosIcon /></div>
            <div className={clsx(style.navEl, style.navElRight, domChildren && domChildren.length === 1 && style.hide)} ref={swiperNext}><ArrowForwardIosIcon /></div>
        </div>
    )

}

const ALLOWED_BLOCKS = ["smartfire/home-hero-tile"];

const Block = ({ fullWidth }) => {
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();
    const ref = useRef();

    const { Children, Child, domChildren } = useChildrenBlocks({ nodeRef: ref });

    let content = (
        <div className={null}>
            <Children allowedBlocks={ALLOWED_BLOCKS} className={style.reveal} />
        </div>
    );

    if (!isEditing) {
        content = <SwiperBlock Child={Child} domChildren={domChildren} />
    }

    return (
        <div className={clsx(style.block, fullWidth && style.fullWidth)} ref={ref}>
            <div className={style.content}>
                {content}
            </div>
        </div>
    )
}

export default defineBlock({
    Block,
    smartProps: {
        fullWidth: smartProps.bool.withDefault(true),
    },
    setup: {
        title: "Home Hero",
    },
});